import { getParamKey } from '../../_data/getParamKey';
import { QuestionMethods } from '../questionMethods.types';
import {
	RenderedSingleSelectQuestion,
	SingleSelectGivenAnswer,
} from './singleSelectMethods.types';

export const addSingleSelectToSearchParams: QuestionMethods<
	RenderedSingleSelectQuestion,
	SingleSelectGivenAnswer
>['addToSearchParams'] = ({ searchParamsDraft, question, givenAnswers }) => {
	const answer = givenAnswers.single.get(question.id);
	if (answer !== undefined) {
		searchParamsDraft.set(getParamKey(question.id), answer ?? '');
	}
};

export const addSingleSelectToGivenAnswers: QuestionMethods<
	RenderedSingleSelectQuestion,
	SingleSelectGivenAnswer
>['addToGivenAnswers'] = ({ givenAnswersDraft, searchParams, question }) => {
	const answer = searchParams.get(getParamKey(question.id));
	if (answer != null) {
		if (answer === '') givenAnswersDraft.single.set(question.id, null);
		else givenAnswersDraft.single.set(question.id, answer);
	}
};
